/**
 * The type of the Redux action which sends page reload log.
 */
export const PAGE_RELOAD_APPLICATION_LOG = 'PAGE_RELOAD_APPLICATION_LOG';
